const ADDITIONAL_FIELD_FILTER_KEY = "additionalFieldFilters"
const STRUCTURED_FILTER_KEYS = new Set([ADDITIONAL_FIELD_FILTER_KEY, "utmFilters"])
const UI_ONLY_FILTER_KEYS = new Set(["datePreset"])

const getRelativeDateRange = (preset, referenceDate = new Date()) => {
    const reference = new Date(referenceDate)
    reference.setHours(12, 0, 0, 0)

    const format = date => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, "0")
        const day = String(date.getDate()).padStart(2, "0")
        return `${year}-${month}-${day}`
    }
    const addDays = (date, days) => {
        const next = new Date(date)
        next.setDate(next.getDate() + days)
        return next
    }
    const startOfMonth = date => new Date(date.getFullYear(), date.getMonth(), 1, 12)
    const endOfMonth = date => new Date(date.getFullYear(), date.getMonth() + 1, 0, 12)

    const today = format(reference)
    const yesterday = format(addDays(reference, -1))
    const ranges = {
        all: { dateStart: "", dateEnd: "" },
        today: { dateStart: today, dateEnd: today },
        yesterday: { dateStart: yesterday, dateEnd: yesterday },
        last7Days: { dateStart: format(addDays(reference, -7)), dateEnd: yesterday },
        last14Days: { dateStart: format(addDays(reference, -14)), dateEnd: yesterday },
        last30Days: { dateStart: format(addDays(reference, -30)), dateEnd: yesterday },
        thisWeek: { dateStart: format(addDays(reference, -reference.getDay())), dateEnd: today },
        lastWeek: { dateStart: format(addDays(reference, -(reference.getDay() + 7))), dateEnd: format(addDays(reference, -(reference.getDay() + 1))) },
        thisMonth: { dateStart: format(startOfMonth(reference)), dateEnd: today },
        lastMonth: {
            dateStart: format(startOfMonth(new Date(reference.getFullYear(), reference.getMonth() - 1, 1, 12))),
            dateEnd: format(endOfMonth(new Date(reference.getFullYear(), reference.getMonth() - 1, 1, 12))),
        },
    }

    return ranges[preset]
}

const resolveRelativeLeadFilterDates = filters => {
    const range = getRelativeDateRange(filters?.datePreset)
    return range ? { ...filters, ...range } : filters
}

const serializeLeadFilters = (filters = {}) => {
    const params = new URLSearchParams()

    Object.entries(filters || {}).forEach(([key, value]) => {
        if (UI_ONLY_FILTER_KEYS.has(key)) return
        if (value === undefined || value === null || value === "") return
        if (Array.isArray(value)) {
            if (!value.length) return
            params.set(key, STRUCTURED_FILTER_KEYS.has(key) ? JSON.stringify(value) : value.join(","))
            return
        }
        if (typeof value === "object") {
            params.set(key, JSON.stringify(value))
            return
        }
        params.set(key, value)
    })

    return params.toString()
}

export { ADDITIONAL_FIELD_FILTER_KEY, getRelativeDateRange, resolveRelativeLeadFilterDates, serializeLeadFilters }
